import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import {
  getBodmasCategory,
  ModalToggle,
  isOpenModal,
  addBodmasCategory,
  updateBodmasCategory,
  isOpenStatusModal,
  statusToggle,
  statusUpdateBodmasCategory,
  deleteBodmasCategory
} from '../../store/bodmasCategorySlice';

const BodmasCategoryTable = () => {
  const navigate = useNavigate();
  const storeVar = useSelector(state => state.bodmasCategory);
  const { layoutURL } = useContext(CustomizerContext);
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const statusModalToggle = () => dispatch(statusToggle());
  const [stateStatus, setStateStatus] = useState('active');
  const [submit, setSubmit] = useState(false);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    categoryId: '',
    name: '',
  });

  useEffect(() => {
    dispatch(getBodmasCategory(formVar.limit, formVar.offset, formVar.status, formVar.keyword));
  }, [dispatch]);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }));
    dispatch(getBodmasCategory(formVar.limit, offset, formVar.status, formVar.keyword));
  };

  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }));
    searchWithDelay(e.target.value);
  };

  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(getBodmasCategory(formVar.limit, formVar.offset, formVar.status, keyword));
    }, typingDelay);
    setTypingTimer(timer);
  };

  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }));
    dispatch(getBodmasCategory(formVar.limit, formVar.offset, e.target.value, formVar.keyword));
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true));
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit Category',
      categoryId: data._id,
      name: data.name,
    }));
  };

  const AddToggleModal = () => {
    dispatch(isOpenModal(true));
    setSubmit(false);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Category',
      name: '',
    }));
  };

  const onValueChange = (event) => {
    setStateStatus(event.target.value);
  };

  const statusToggleModal = (data) => {
    dispatch(isOpenStatusModal(true));
    setStateStatus(data.status);
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      categoryId: data._id,
    }));
  };

  const submitMenu = () => {
    if (nameValid()) {
      setSubmit(true);
      return null;
    }
    setSubmit(false);

    if (formVar.editState) {
      dispatch(updateBodmasCategory(formVar.categoryId, { name: formVar.name }));
    } else {
      dispatch(addBodmasCategory({ name: formVar.name, status: 'active' }));
    }
  };

  const submitStatus = () => {
    dispatch(statusUpdateBodmasCategory(formVar.categoryId, stateStatus));
  };

  const nameValid = () => {
    if (!formVar.name) {
      return "Category Name is required";
    }
  };

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this category!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        dispatch(deleteBodmasCategory(data._id));
      }
    });
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
                <Input
                  className="form-control"
                  placeholder='Serch..'
                  type="text"
                  id="yourInputId"
                  value={formVar.keyword}
                  onChange={(e) => searchState(e)}
                />
              </Col>
              <Col md="4">
                <Input
                  className="form-control form-control-inverse btn-square"
                  name="select"
                  type="select"
                  value={formVar.status}
                  onChange={handleInputChange}
                >
                  <option value='active'>ACTIVE</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Category
                  </Btn>
                </div>
              </Col>
            </Row>
          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Category Name</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.categoryData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.name}</td>
                    <td>
                      {item.status === 'active' && (
                        <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>Active</span>
                        </span>
                      )}
                      {item.status === 'pending' && (
                        <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>Pending</span>
                        </span>
                      )}
                      {item.status === 'DEACTIVE' && (
                        <span className={`font-danger w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                          <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                          &nbsp; <span>{item.status}</span>
                        </span>
                      )}
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-info action-icon'>
                          <i className="fa fa-toggle-on fa-lg" onClick={(e) => statusToggleModal(item)}></i>
                          <div className="tooltipCustom">Status Update</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {storeVar.totalCategory <= 0 && <Empty />}
        </Card>
        {storeVar.totalCategory > 0 && (
          <Pagination
            currentPage={formVar.currentPage}
            totalItem={storeVar.totalCategory}
            itemsPerPage={formVar.limit}
            showEllipsisAfter={true}
            visiblePageCount={3}
            onPageChange={pageChange}
          />
        )}
      </Col>

      {/* Add / Edit Modal */}
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle}>
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Category Name</Label>
            <Input
              className="form-control"
              type="text"
              placeholder='Enter Category Name'
              onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, name: e.target.value }))}
              value={formVar.name}
            />
            {submit && nameValid() ? <span className='d-block font-danger'>{nameValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>

      {/* Status Modal */}
      <CommonModal isOpen={storeVar.isStatusOpenModal} title={'Status'} toggler={statusModalToggle}>
        <Col>
          <div className='d-flex m-15 m-checkbox-inline justify-content-center custom-radio-ml'>
            <div className='radio radio-primary'>
              <Input
                id='radioinline1'
                type='radio'
                className="radio_animated"
                name='radio1'
                checked={stateStatus === 'active'}
                onChange={onValueChange}
                value='active'
              />
              <Label className='mb-0' for='radioinline1'>
                <span className='digits'>ACTIVE</span>
              </Label>
            </div>
            <div className='radio radio-primary'>
              <Input
                id='radioinline3'
                type='radio'
                className="radio_animated"
                name='radio3'
                checked={stateStatus === 'pending'}
                onChange={onValueChange}
                value='pending'
              />
              <Label className='mb-0' for='radioinline3'>
                <span className='digits'>PENDING</span>
              </Label>
            </div>
          </div>
        </Col>
        <ModalFooter className='justify-content-center'>
          <Btn attrBtn={{ color: 'secondary', onClick: statusModalToggle }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitStatus }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default BodmasCategoryTable;
